import React from "react";
import CrudForm from "../../components/forms/custom/CrudForm";
import BtnButton from "../../components/forms/elements/BtnButton";
import BtnSubmit from "../../components/forms/elements/BtnSubmit";
import SelectCategoriaProdutoServicoByUsuario from "../../components/app/SelectCategoriaProdutoServicoByUsuario";
import SelectTipoProdutoServicoByCategoria from "../../components/app/SelectTipoProdutoServicoByCategoria";
import Util from "../../utils/Util";
import Config from "../../Config";
import InputCheckSwitch from "../../components/forms/elements/InputCheckSwitch";
import BtnGroup from "../../components/forms/elements/BtnGroup";
import SelectOrdemTipoUsuario from "../../components/app/SelectOrdemTipoUsuario";

export default class FormRelatorioProduto001 extends CrudForm {

    constructor(props) {
        super(props);

        this.state.isModal = true;

        this.urlRelatorio = "relatorio/produto-001";

        this.state.model = {
            idCategoriaProdutoServico: "",
            idTipoProdutoServico: "",
            flProdutoSemEstoque: false,
            flControlaEstoque: false,
            flProdutoEmPromocao: false,
            orientation: "P",
            destination: "I",
            output: "PDF",
            flMarcaDagua: true,
            idOrdemTipo: "",
            flFiltroCdTipo: "T"
        };

        this.state.orientation = [
            { value: 'P', label: 'Vertical' },
            { value: 'L', label: 'Horizontal' },
        ]

        this.state.destination = [
            { value: 'I', label: 'Tela' },
            { value: 'D', label: 'Download' },
        ]

        this.state.output = [
            { value: 'PDF', label: 'PDF' },
            { value: 'XLS', label: 'XLS' },
        ]

        this.state.filtroTipo = [
            { value: "T", label: "Todos" },
            { value: "P", label: "Produto" },
            { value: "S", label: "Serviço" },
        ]
    }

    componentDidMount() {
        super.componentDidMount();
    }

    componentWillUnmount() {
        super.componentWillUnmount();
    }

    onSubmit(e) {
        Util.openNewWindow(Config.getUrlApi() + this.urlRelatorio, this.state.model);
    }

    getRenderFields() {
        return (
            <>
                <div className="row mb-3 g-3">
                    <SelectOrdemTipoUsuario md={12} label="Tipo da Ordem" required placeholder="Selecione o Tipo da Ordem" name="idOrdemTipo" value={this.state.model.idOrdemTipo} onChange={this.handleChange} />
                    <SelectCategoriaProdutoServicoByUsuario showBtnNewForm={false} md={12} label="Categoria de Produto" placeholder="Selecione a Categoria do Produto" name="idCategoriaProdutoServico" value={this.state.model.idCategoriaProdutoServico} onChange={this.handleChange} />
                    <SelectTipoProdutoServicoByCategoria showBtnNewForm={false} md={12} idCategoriaProdutoServico={this.state.model.idCategoriaProdutoServico} disabled={!this.state.model.idCategoriaProdutoServico} label="Tipo de Produto" placeholder="Selecione o Tipo do Produto" name="idTipoProdutoServico" value={this.state.model.idTipoProdutoServico} onChange={this.handleChange} />
                </div>
                <div className="row px-3 mb-3">
                    <InputCheckSwitch label="Somente produtos com controle de estoque" name="flControlaEstoque" checked={Boolean(this.state.model.flControlaEstoque)} onChange={this.handleChange} />
                    <InputCheckSwitch label="Somente produtos sem estoque" name="flProdutoSemEstoque" checked={Boolean(this.state.model.flProdutoSemEstoque)} onChange={this.handleChange} />
                    <InputCheckSwitch label="Somente produtos em promoção" name="flProdutoEmPromocao" checked={Boolean(this.state.model.flProdutoEmPromocao)} onChange={this.handleChange} />
                    <InputCheckSwitch label="Mostrar marca d'água" name="flMarcaDagua" checked={Boolean(this.state.model.flMarcaDagua)} onChange={this.handleChange} />
                </div>
                <div className="row mb-3">
                    <BtnGroup md={6} sizing="sm" className="w-100" name="flFiltroCdTipo" value={this.state.model.flFiltroCdTipo} label="Tipo do Produto/Serviço" options={this.state.filtroTipo} onChange={this.handleChange} opcionalLabel={false} />
                </div>
                <div className="row mb-3">
                    <BtnGroup md={4} sizing="sm" className="w-100" name="orientation" value={this.state.model.orientation} label="Disposição da Página" options={this.state.orientation} onChange={this.handleChange} required />
                    <BtnGroup md={4} sizing="sm" className="w-100" name="destination" value={this.state.model.destination} label="Destino do Relatório" options={this.state.destination} onChange={this.handleChange} required />
                    <BtnGroup md={4} sizing="sm" className="w-100" name="output" value={this.state.model.output} label="Formato de Saída" options={this.state.output} onChange={this.handleChange} required />
                </div>
            </>
        );
    }

    getBtns() {
        return (
            <div className="d-grid gap-2 d-md-flex">
                <BtnButton className="ms-auto btn-outline-secondary" onClick={this.handleClose}> Cancelar </BtnButton>
                <div className="vr"></div>
                <BtnSubmit className="btn-primary"> Emitir Relatório </BtnSubmit>
            </div>);
    }

    render() {
        return super.render();
    }
}